import { Building, Clock, DollarSign, MapPin, Phone } from "lucide-react";
import * as React from "react";

// Define props type
interface StationInfoProps {
  station: {
    address: string | null;
    hours: string | null;
    costDescription: string | null;
    parkingLevel: string | null;
    formattedPhoneNumber: string | null;
  } | null;
}

export function StationInfo({ station }: StationInfoProps) {
  if (!station) {
    return null;
  }

  const infoItems = [
    {
      icon: MapPin,
      label: "Endereço",
      value: station.address,
      capitalize: true,
    },
    { icon: Clock, label: "Horário", value: station.hours },
    { icon: DollarSign, label: "Preço", value: station.costDescription },
    {
      icon: Building,
      label: "Estacionamento",
      value: station.parkingLevel,
      capitalize: true,
    },
    { icon: Phone, label: "Telefone", value: station.formattedPhoneNumber },
  ];

  const visibleItems = infoItems.filter((item) => item.value);

  if (visibleItems.length === 0) {
    return null; // Don't render the component if there's no info to show
  }

  return (
    <div className="w-full rounded-lg border border-border bg-white p-4 shadow-md dark:bg-gray-800">
      <h2 className="mb-4 text-xl font-semibold text-card-foreground">
        Informações da Estação
      </h2>

      <div className="divide-y divide-border/30 pt-4 dark:divide-gray-700">
        {visibleItems.map((item, index) => (
          <div key={index} className="flex items-start gap-3 py-3.5">
            <item.icon className="mt-0.5 h-4.5 w-4.5 flex-shrink-0 text-primary/70 dark:text-primary/80" />
            <div>
              <span className="text-sm font-medium text-gray-800 dark:text-gray-200">
                {item.label}
              </span>
              <p
                className={`mt-0.5 text-sm text-gray-600 dark:text-gray-400 ${item.capitalize ? "capitalize" : ""}`}
              >
                {item.value}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
